import {Base,Axios} from "@/api/Base"

export class PaymentReportPersistencyExport extends Base {
    path = "payment/exportReportPersistency";
    download(param = {}) {
      return Axios.get(this.path,{ params: param, responseType: "blob" })
  }
}